import * as React from 'react'

const SvgAddToGlossaryIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 13.125v-1.25H5.625v-1.25h-1.25v1.25H1.25v1.25h5.134A5.37 5.37 0 015 15.611a5.793 5.793 0 01-.904-1.236H2.708a6.784 6.784 0 001.34 2.06 9.163 9.163 0 01-2.173 1.144l.439 1.171c.961-.35 1.865-.842 2.681-1.46.82.618 1.727 1.11 2.692 1.46l.438-1.17a9.165 9.165 0 01-2.173-1.142 6.446 6.446 0 001.705-3.313H8.75zm-1.77-5h1.353L5.47 1.25H4.114L1.25 8.125h1.354l.521-1.25h3.333l.521 1.25zm-3.334-2.5l1.145-2.75 1.146 2.75H3.647zM15.5 9.625v-3.5h-1.25v3.5h-3.5v1.25h3.5v3.5h1.25v-3.5H19v-1.25h-3.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgAddToGlossaryIcon
